import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import { FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, orientationOptionIds } from 'commons/constants';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import { getMainImageImgixPropsForPhoto, getThumbnailImageImgixPropsForPhoto } from './helpers/imgix-props';
import Prefetcher from '../../../essentials/Prefetcher';
import PDPDesktopHeroGalleryUI from './PDPDesktopHeroGalleryUI';
import usePDPDesktopHeroSizeProps from './helpers/usePDPDesktopHeroSizeProps';
const getPrefetcherConfig = (lastHoveredConfigPhotos, selectedPhoto, enableCrops, mainPhotoSizeProps) => {
  if (!selectedPhoto || !lastHoveredConfigPhotos.length) {
    return {};
  }
  const mainPhoto = lastHoveredConfigPhotos[selectedPhoto.type === 'studio' || !lastHoveredConfigPhotos[selectedPhoto.index] ? 0 : selectedPhoto.index];
  if (!mainPhoto.src) {
    return {};
  }
  const onRenderAssets = [...lastHoveredConfigPhotos.slice(0, 5).map(({
    src,
    type
  }) => ({
    url: src,
    imgixProps: getThumbnailImageImgixPropsForPhoto({
      src,
      type
    })
  })), {
    url: mainPhoto.src,
    imgixProps: {
      ...getMainImageImgixPropsForPhoto(mainPhoto, enableCrops),
      ...mainPhotoSizeProps
    },
    isProductImage: true
  }];
  return {
    onRenderAssets
  };
};
const PDPDesktopHeroGallery = t0 => {
  const $ = _c(74);
  const {
    isEditOrder: t1,
    mainPhotoLink,
    mode: t2,
    pdpIsModularBYOProduct,
    slug,
    productHeroImage: t3,
    productCylindoHeroImage: t4
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const productCylindoHeroImage = t4 === undefined ? null : t4;
  const {
    loading,
    error,
    data,
    actions
  } = usePDPPhotos(null, slug);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  const {
    data: t5
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t5 === undefined ? {} : t5;
  const t6 = mode === "pdp";
  let t7;
  if ($[0] !== t6) {
    t7 = {
      isPDPDesktop: true,
      deferCylindoFetch: t6
    };
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    cylindoConfigurationPhotos,
    isMechanicalOpen,
    toggleMechanicalOpen,
    isCylindoConfigurationPhotos,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    hasMultipleDimensionShots,
    shouldShowDimensionThumbnail,
    goToNextDimensionShot,
    goToPreviousDimensionShot
  } = usePDPCylindoViewer(t7);
  let t8;
  if ($[2] !== data || $[3] !== modularPhotosData?.data || $[4] !== pdpIsModularBYOProduct) {
    t8 = pdpIsModularBYOProduct ? modularPhotosData?.data ?? {} : data;
    $[2] = data;
    $[3] = modularPhotosData?.data;
    $[4] = pdpIsModularBYOProduct;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const {
    campaign,
    configurationPhotos: nonCylindoConfigurationPhotos,
    dimensionalImage,
    enableCrops,
    introVideoIds,
    isConfigFlipped,
    isVideoSelected,
    lastHoveredConfigPhotos,
    productName,
    selectedPhoto,
    studioPhotos: allStudioPhotos
  } = t8;
  const configurationPhotos = useRemoveBrokenImageUrls(isCylindoConfigurationPhotos ? cylindoConfigurationPhotos : nonCylindoConfigurationPhotos);
  const studioPhotos = useRemoveBrokenImageUrls(allStudioPhotos);
  let t9;
  if ($[6] !== actions || $[7] !== modularPhotosData?.actions || $[8] !== pdpIsModularBYOProduct) {
    t9 = pdpIsModularBYOProduct ? modularPhotosData?.actions ?? {} : actions;
    $[6] = actions;
    $[7] = modularPhotosData?.actions;
    $[8] = pdpIsModularBYOProduct;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const {
    setSelectedPhoto,
    setIsVideoSelected
  } = t9;
  let t10;
  bb0: {
    if (!productCylindoHeroImage?.src) {
      t10 = false;
      break bb0;
    }
    const norm = _temp;
    const selectedUpholstery = selectedOptionsExtended?.[FABRIC_PRODUCT_OPTION_ID]?.value || selectedOptionsExtended?.[LEATHER_PRODUCT_OPTION_ID]?.value || null;
    const selectedSku = selectedUpholstery?.sku != null ? String(selectedUpholstery.sku) : null;
    const defaultSku = productCylindoHeroImage.defaultUpholsterySku != null ? String(productCylindoHeroImage.defaultUpholsterySku) : null;
    const upholsteryMatches = selectedSku && defaultSku ? selectedSku === defaultSku : norm(selectedUpholstery?.value) === norm(productCylindoHeroImage.defaultUpholsteryValue);
    const selectedOrientationId = orientationOptionIds.find(id => selectedOptionsExtended?.[id]);
    const selectedOrientation = selectedOrientationId ? selectedOptionsExtended?.[selectedOrientationId]?.value?.value : null;
    const orientationMatches = norm(selectedOrientation) === norm(productCylindoHeroImage.defaultOrientation);
    t10 = !(upholsteryMatches && orientationMatches);
  }
  const isNonDefaultCylindoVariant = t10;
  let t11;
  bb1: {
    if (selectedPhoto?.type === "dimensional") {
      if (currentDimensionShot) {
        let t12;
        if ($[10] !== currentDimensionShot.dimensionCode || $[11] !== currentDimensionShot.src || $[12] !== selectedPhoto) {
          t12 = {
            ...selectedPhoto,
            src: currentDimensionShot.src,
            dimensionCode: currentDimensionShot.dimensionCode
          };
          $[10] = currentDimensionShot.dimensionCode;
          $[11] = currentDimensionShot.src;
          $[12] = selectedPhoto;
          $[13] = t12;
        } else {
          t12 = $[13];
        }
        t11 = t12;
        break bb1;
      }
      if (dimensionalImage?.src) {
        let t12;
        if ($[14] !== dimensionalImage.src || $[15] !== selectedPhoto) {
          t12 = {
            ...selectedPhoto,
            src: dimensionalImage.src
          };
          $[14] = dimensionalImage.src;
          $[15] = selectedPhoto;
          $[16] = t12;
        } else {
          t12 = $[16];
        }
        t11 = t12;
        break bb1;
      }
      t11 = selectedPhoto;
      break bb1;
    }
    if (isCylindoConfigurationPhotos && selectedPhoto?.type === "cylindo") {
      t11 = selectedPhoto;
      break bb1;
    }
    if (productCylindoHeroImage?.src && !isNonDefaultCylindoVariant && !isCylindoConfigurationPhotos && selectedPhoto?.type !== "studio") {
      let t12;
      if ($[17] !== productCylindoHeroImage.src) {
        t12 = {
          type: "cylindo",
          id: productCylindoHeroImage.src,
          src: productCylindoHeroImage.src
        };
        $[17] = productCylindoHeroImage.src;
        $[18] = t12;
      } else {
        t12 = $[18];
      }
      t11 = t12;
      break bb1;
    }
    if (isCylindoAvailable && !selectedPhoto) {
      if (isCylindoConfigurationPhotos) {
        t11 = cylindoConfigurationPhotos[0];
        break bb1;
      }
      let t12;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
          type: "cylindo"
        };
        $[19] = t12;
      } else {
        t12 = $[19];
      }
      t11 = t12;
      break bb1;
    }
    const resolved = selectedPhoto || studioPhotos[0];
    if (resolved?.src || resolved?.type === "dimensional" || resolved?.type === "cylindo") {
      t11 = resolved;
      break bb1;
    }
    if (productHeroImage?.src) {
      let t12;
      if ($[20] !== productHeroImage.src) {
        t12 = {
          type: "studio",
          id: productHeroImage.src,
          src: productHeroImage.src
        };
        $[20] = productHeroImage.src;
        $[21] = t12;
      } else {
        t12 = $[21];
      }
      t11 = t12;
      break bb1;
    }
    t11 = resolved;
  }
  const selectedPhotoToShow = t11;
  let t12;
  if ($[22] !== currentDimensionShot || $[23] !== dimensionalImage || $[24] !== selectedPhoto?.type) {
    t12 = () => {
      if (currentDimensionShot) {
        return currentDimensionShot;
      }
      if (selectedPhoto?.type === "dimensional" && dimensionalImage?.src) {
        return {
          src: dimensionalImage.src,
          dimensionCode: "static",
          id: "static-dimensional"
        };
      }
      return {
        src: "",
        dimensionCode: "none",
        id: "no-dimensional-shot"
      };
    };
    $[22] = currentDimensionShot;
    $[23] = dimensionalImage;
    $[24] = selectedPhoto?.type;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  selectedPhoto?.type;
  let t13;
  if ($[26] !== t12) {
    t13 = t12();
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const currentDimensionShotToShow = t13;
  if (loading && !productHeroImage?.src) {
    const t14 = pdpSelectedCustomizerTab === "decide-later";
    let t15;
    if ($[28] !== mode || $[29] !== t14) {
      t15 = <PDPDesktopHeroGalleryUI loading={true} mode={mode} showDecideLaterOverlay={t14} />;
      $[28] = mode;
      $[29] = t14;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    return t15;
  }
  if (!data) {
    return null;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let t14;
  if ($[31] !== enableCrops || $[32] !== lastHoveredConfigPhotos || $[33] !== mainPhotoSizeProps || $[34] !== selectedPhoto) {
    t14 = getPrefetcherConfig(lastHoveredConfigPhotos, selectedPhoto, enableCrops, mainPhotoSizeProps);
    $[31] = enableCrops;
    $[32] = lastHoveredConfigPhotos;
    $[33] = mainPhotoSizeProps;
    $[34] = selectedPhoto;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const t15 = pdpSelectedCustomizerTab === "decide-later";
  let t16;
  if ($[36] !== cylindoConfigurationPhotos || $[37] !== setSelectedPhoto) {
    t16 = t17 => {
      const {
        id: id_0,
        index,
        src,
        type
      } = t17;
      if (type === "cylindo") {
        setSelectedPhoto?.(cylindoConfigurationPhotos[index] ?? null);
        return;
      }
      setSelectedPhoto?.({
        id: id_0,
        index,
        src,
        type
      });
    };
    $[36] = cylindoConfigurationPhotos;
    $[37] = setSelectedPhoto;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const t17 = !isCylindoAvailable;
  let t18;
  if ($[39] !== campaign || $[40] !== configurationPhotos || $[41] !== currentDimensionShotToShow || $[42] !== cylindoFeatures || $[43] !== dimensionShotUrls || $[44] !== dimensionalImage || $[45] !== enableCrops || $[46] !== goToNextDimensionShot || $[47] !== goToPreviousDimensionShot || $[48] !== hasMultipleDimensionShots || $[49] !== introVideoIds || $[50] !== isConfigFlipped || $[51] !== isCylindoAvailable || $[52] !== isCylindoConfigurationPhotos || $[53] !== isEditOrder || $[54] !== isMechanicalOpen || $[55] !== isVideoSelected || $[56] !== mainPhotoLink || $[57] !== mode || $[58] !== pdpIsModularBYOProduct || $[59] !== productName || $[60] !== selectedDimensionShotIndex || $[61] !== selectedPhotoToShow || $[62] !== setIsVideoSelected || $[63] !== shouldShowDimensionThumbnail || $[64] !== studioPhotos || $[65] !== t15 || $[66] !== t16 || $[67] !== t17 || $[68] !== toggleMechanicalOpen || $[69] !== viewGalleryImageEvent) {
    t18 = <PDPDesktopHeroGalleryUI configurationPhotos={configurationPhotos} isMechanicalOpen={isMechanicalOpen} toggleMechanicalOpen={toggleMechanicalOpen} selectedPhoto={selectedPhotoToShow} dimensionsImage={dimensionalImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} isEditOrder={isEditOrder} enableCrops={enableCrops} loading={false} showDecideLaterOverlay={t15} setSelectedPhoto={t16} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShotToShow} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} goToNextDimensionShot={goToNextDimensionShot} goToPreviousDimensionShot={goToPreviousDimensionShot} studioPhotos={studioPhotos} isConfigFlipped={isConfigFlipped} introVideoIds={introVideoIds} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} productName={productName} cylindoFeatures={cylindoFeatures} isCylindoAvailable={isCylindoAvailable} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} mode={mode} mainPhotoLink={mainPhotoLink} campaign={campaign} displayOnlyConfigImages={t17} />;
    $[39] = campaign;
    $[40] = configurationPhotos;
    $[41] = currentDimensionShotToShow;
    $[42] = cylindoFeatures;
    $[43] = dimensionShotUrls;
    $[44] = dimensionalImage;
    $[45] = enableCrops;
    $[46] = goToNextDimensionShot;
    $[47] = goToPreviousDimensionShot;
    $[48] = hasMultipleDimensionShots;
    $[49] = introVideoIds;
    $[50] = isConfigFlipped;
    $[51] = isCylindoAvailable;
    $[52] = isCylindoConfigurationPhotos;
    $[53] = isEditOrder;
    $[54] = isMechanicalOpen;
    $[55] = isVideoSelected;
    $[56] = mainPhotoLink;
    $[57] = mode;
    $[58] = pdpIsModularBYOProduct;
    $[59] = productName;
    $[60] = selectedDimensionShotIndex;
    $[61] = selectedPhotoToShow;
    $[62] = setIsVideoSelected;
    $[63] = shouldShowDimensionThumbnail;
    $[64] = studioPhotos;
    $[65] = t15;
    $[66] = t16;
    $[67] = t17;
    $[68] = toggleMechanicalOpen;
    $[69] = viewGalleryImageEvent;
    $[70] = t18;
  } else {
    t18 = $[70];
  }
  let t19;
  if ($[71] !== t14 || $[72] !== t18) {
    t19 = <Prefetcher {...t14}>{t18}</Prefetcher>;
    $[71] = t14;
    $[72] = t18;
    $[73] = t19;
  } else {
    t19 = $[73];
  }
  return t19;
};
PDPDesktopHeroGallery.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  mainPhotoLink: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    // The default selection this frame represents, so the gallery can confirm the current
    // (URL/user) selection still matches before painting it as the SSR LCP (CON-8293).
    defaultUpholsteryValue: PropTypes.string,
    defaultUpholsterySku: PropTypes.string,
    defaultOrientation: PropTypes.string
  })
};
export default PDPDesktopHeroGallery;
function _temp(value) {
  return value == null ? null : String(value).trim().toLowerCase();
}